import { ScreenTypes } from 'Types/common';
import AddChildScreen from './components/AddChildScreen';
import ChildScreen from './components/ChildScreen';
import EditScreen from './components/EditScreen';
import EndScreen from './components/EndScreen';
import StartScreen from './components/StartScreen';
import SummaryClassificator from './components/SummaryClassificator';
import SummaryScreen from './components/SummaryScreen';

export default {
  [ScreenTypes.START]: StartScreen,
  [ScreenTypes.EDIT]: EditScreen,
  [ScreenTypes.CHILD_ADD]: AddChildScreen,
  [ScreenTypes.SUMMARY]: SummaryScreen,
  [ScreenTypes.SUMMARY_ADD]: SummaryScreen,
  [ScreenTypes.SUBSUMMARY_FILTERED]: SummaryScreen,
  [ScreenTypes.SUMMARY_CLASIFICATOR]: SummaryClassificator,
  [ScreenTypes.CHILD]: ChildScreen,
  [ScreenTypes.END]: EndScreen,
};
